 (function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'CruiseSheetPrepare',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		$(document).bind('drag-drop-files-changed', function attachmentsChanged(e, data) {
			$('#cruisesheetprepare-attachments_changed').val(1);
		});

		// user toggles a classification (Inside, Ocean view, Balcony, Suite, Unclassified) of ship categories
		$('#cruise-sheet-category-filter').find(':checkbox').on('change', function click(e)
		{
			var $self       = $(this),
			    checked_val = $(this).val(),
			    $rows       = $('#ship-categories-table').find('.' + checked_val);

			$rows.each(function iti( key, value ) {
				var $element = $(this);

				if ($self.prop('checked')) {
					// on
					$element.removeClass('hidden');
				} else {
					// off
					$element.addClass('hidden');

					// since row will be hidden, remove any currently checked ship_categories
					$element.find('.ship-category-check').prop('checked', false);

					// since ship_category is unchecked, remove any values in row's price fields
					Adzuki.CruiseSheets.clearPricingFields($element);
				}
			});

			categoriesVisible();
		});

		// When toggling between manual and econnect divs, set hidden field value
		$('.nav-tabs').find('a').on('click', function click(e)
		{
			var pricing_method = $(this).data('pricing-method');
			$('#cruisesheetprepare-pricing_method').val(pricing_method);
		});

		// after iFrame content loads
		$("#cruise-sheets-preview").on("load", function previewLoad() {
			$('.cruise-sheets-preview-loader').addClass('hidden');
			$('#cruise-sheets-preview').removeClass('hidden');

			// enable send button
			$('.send-cruise-sheet').prop('disabled', false);
			$('.send-cruise-sheet').addClass('btn-primary');

			// enable send text button
			$('.send-cruise-sheet-text').prop('disabled', false);
		});

		// any changes to form, we want to disable the send and send text button until they successfully save the cruise sheet
		$("#cruise-sheet-form").on("change", function formChange() {
			$('.send-cruise-sheet').prop('disabled', true);
			$('.send-cruise-sheet-text').prop('disabled', true);
		});

		// send cruise sheet
		$(".send-cruise-sheet").on("click", function clickSend() {
			window.location.href = Adzuki.base_uri + '/CruiseSheets/send/' + $('#cruisesheetprepare-id').val();
		});

		// send cruise sheet via text
		$('.send-cruise-sheet-text').on('click', function clickSendText() {
			window.location.href = Adzuki.base_uri + '/CruiseSheets/sendText/' + $('#cruisesheetprepare-id').val();
		});

		// if recipient removed, disable send and send text button until form passes validation and is saved
		$(".selected-recipients").on('click', '.remove', function remove() {
			$('.send-cruise-sheet').prop('disabled', true);
			$('.send-cruise-sheet-text').prop('disabled', true);
		});

		// this toggles the live pricing option and submits the form to move it forward
		$('.pricing-option > .btn-default').click(function linkToPressed() {
			var $self  = $(this),
			    $radio = $self.find('.radio-inline');

			if ($radio.val() === 'econnect') {
				$('#cruisesheetprepare-pricing_method').val('econnect');
				$('#cruise-sheet-form').submit();

				$('#manual').addClass('hidden');
				$('#econnect').removeClass('hidden');
			} else {
				$('#ccruisesheetprepare-pricing_method').val('manual');

				$('#econnect').addClass('hidden');
				$('#manual').removeClass('hidden');
			}
		});

		$('.get-new-pricing').click(function getNewPricing() {
			$('.live-pricing-btn').trigger('click');
		});

		// if the table of currently selected excursions exceeds X rows, we will hide them with ability to expand/collapse
		$( ".cruise-sheet-information" ).on( "click", "#toggle-port-excursions", function expandClick(e) {
			var $self        = $(this),
			    current_text = $self.html(),
			    $extra       = $('#port-excursions').find('.excess');

			e.preventDefault();

			$self.html($self.data('opposite'));
			$self.data('opposite', current_text);
			$extra.toggleClass('hidden');
		});

		/**
		 * Are any ship categories visible based on the category filter?  If not, hide the whole "table"
		 */
		function categoriesVisible()
		{
			var $rows   = $('#ship-categories-table').find('.table-row'),
			    visible = false;

			$rows.each(function iti( key, value ) {
				var $element = $(this);

				if (!$element.hasClass('hidden')) {
					visible = true;
					return false;
				}
			});

			if (visible) {
				$('#ship-categories-table').removeClass('hidden');
			} else {
				$('#ship-categories-table').addClass('hidden');
			}
		}
	};

	form.success = function success(response)
	{
		var url,
		    internal_url,
		    link;

		// if unchecked upon save, clear out any excursion selection summary html
		if ($('#cruisesheetdetails-allow_excursions').prop('checked') === false) {
			$('#excursion-summary').html('');
		}

		// this is unique to the live pricing option to redirect the form to start the cruise sheet
		if (response.status === 'live_pricing') {
			window.location.href = response.data;

			return false;
		}

		if (!Adzuki.Form.hasError(response)) {
			// in here, so successful form submission
			$('#cruisesheetprepare-id').val(response.data['cruise_sheet_id']);

			if (response.data['cs_text_message_id']) {
				$('#cruisesheetprepare-cruise_sheet_text_message_id').val(response.data['cs_text_message_id']);
			} else {
				$('#cruisesheetprepare-cruise_sheet_text_message_id').val('');
			}

			$('#cruise-sheets-preview').addClass('hidden');

			$('.cruise-sheets-preview-text').addClass('hidden');
			$('.cruise-sheets-preview-loader').removeClass('hidden');

			// reload iFrame with cruise sheet in it
			internal_url = response.data['cpmaxx_cruise_sheet_url'];
			$('#cruise-sheets-preview').attr("src", internal_url);

			$('#cruise-sheet-url-div').removeClass('hidden');

			url  = response.data['cruise_sheet_url'];
			link = '<a target="_blank" href="' + url + '">' + url + '<a>';
			$('#cruise-sheet-url').html(link);
		}
		return false;
	};

}(jQuery, window.Adzuki || {}));
